import React, { useEffect, useState } from "react";
import axios from "axios";
import images from "../../../Utils/importImages"; // Adjust the path according to your folder structure
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import {
  PipelinesListFetcher,
  setSelectedPipelineId,
  setPipelineAutoSelectResolved,
  setShowSignUpPopup,
  setisUserLogin,
  setUserLoggedInData,
} from "../../../Redux/Slices/User_Slices/User-SLICE";
import { enableResultPageSearchButton } from "../../../Redux/Slices/Flight_Slices/ResultPage-Flights-SLICE";
import {
  getLocalStorageJSON,
  setLocalStorageJSON,
  removeLocalStorageJSON,
} from "../../../Utils/localStorageFunc";
import { MAIN_URL } from "../../../Configs/Urls";
import { getNearestRegionCode } from "../../../Constants/NearestRegionMap";
import { LogoutUser } from "../../../Redux/Apis/User-Apis";
import Swal from "sweetalert2";

function Header() {
  let dispatch = useDispatch();

  const {
    userLoggedInData,
    showSignUpPopup,
    isUserLogin,
    isAdminLogin,
    pipelinesList,
    selectedPipelineId,
    UserCurrentLocationData,
    status,
    userLoading,
  } = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(PipelinesListFetcher());
  }, []);

  const [currencies, setCurrencies] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(
    () => getLocalStorageJSON("selectedCurrency") || "USD"
  );

  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const res = await axios.get(`${MAIN_URL}global/currency-rates/currencies`);
        setCurrencies(res.data?.data || []);
      } catch (err) {
        console.error("Failed to load currencies", err);
      }
    };

    fetchCurrencies();
  }, []);

  // Once the user manually picks a pipeline, it's persisted to localStorage
  // (see onChange below) and that value is what the store's initial state
  // reads on load — so it's already active by the time this component
  // mounts. Skip the country-based auto-default entirely in that case; it
  // should only ever kick in for a first-time visitor with no saved choice.
  const [hasAutoSelectedPipeline, setHasAutoSelectedPipeline] = useState(
    () => getLocalStorageJSON("selectedPipelineId") != null
  );
  // Same idea for currency: only auto-pick it alongside the region on a
  // genuine first visit — never override a currency the user (or a previous
  // auto-select) already saved. Split into its own effect (rather than
  // folded into the pipeline one below) because `currencies` loads via its
  // own async fetch and may not be ready yet on the pipeline effect's first
  // run — that effect flips hasAutoSelectedPipeline to true immediately,
  // which would otherwise short-circuit this logic before currencies exist.
  const [hasAutoSelectedCurrency, setHasAutoSelectedCurrency] = useState(
    () => getLocalStorageJSON("selectedCurrency") != null
  );
  // Currency of whichever pipeline the auto-select effect below picked —
  // read by the currency effect once `currencies` is actually loaded.
  const [autoSelectedCurrency, setAutoSelectedCurrency] = useState(null);

  useEffect(() => {
    if (hasAutoSelectedPipeline || status !== "idle" || pipelinesList.length === 0) return;

    const matchedByCountry = pipelinesList.find(
      (pipeline) => pipeline.code === UserCurrentLocationData?.code
    );
    // No exact-match region for this country (e.g. a New Zealand visitor,
    // where we only serve Australia) — fall back to whichever served region
    // is geographically nearest, before finally defaulting to India.
    const nearestRegionCode = getNearestRegionCode(
      UserCurrentLocationData?.code,
      UserCurrentLocationData?.continent_code
    );
    const matchedByNearestRegion = pipelinesList.find(
      (pipeline) => pipeline.code === nearestRegionCode
    );
    const indiaPipeline = pipelinesList.find((pipeline) => pipeline.code === "IN");
    const defaultPipeline = matchedByCountry || matchedByNearestRegion || indiaPipeline;

    if (defaultPipeline) {
      dispatch(setSelectedPipelineId(defaultPipeline.id));
      // Currency follows whichever region just got auto-selected here, not
      // the raw geolocation country — e.g. a New Zealand visitor lands on
      // the Australia region, so their currency should default to AUD, not NZD.
      // Comes straight from the pipeline's own `currency` column now, not a
      // separate hardcoded region→currency map.
      setAutoSelectedCurrency(defaultPipeline.currency);
    }
    setHasAutoSelectedPipeline(true);
    // Mirrors into Redux so pages outside Header's own tree (ResultPage.jsx's initial
    // SearchTheFlights dispatch) can wait for this before firing a search — see this flag's own
    // docblock in User-SLICE.js for the race condition it closes.
    dispatch(setPipelineAutoSelectResolved(true));
  }, [status, pipelinesList, UserCurrentLocationData, hasAutoSelectedPipeline]);

  useEffect(() => {
    if (hasAutoSelectedCurrency || !autoSelectedCurrency || currencies.length === 0) return;

    const matchedCurrency = currencies.find((currency) => currency.code === autoSelectedCurrency);
    if (matchedCurrency) {
      setSelectedCurrency(matchedCurrency.code);
      setLocalStorageJSON("selectedCurrency", matchedCurrency.code);
    }
    setHasAutoSelectedCurrency(true);
  }, [hasAutoSelectedCurrency, autoSelectedCurrency, currencies]);

    console.log("isUserLogin, isAdminLogin is : " , isUserLogin, isAdminLogin);
    

  // Which nav modules (Flights/Hotels/Packages) show is driven by the selected
  // region's show_* flags (see admin's Region-Modules tabs) — stays hidden until
  // the pipeline list/selection actually resolves, so the nav doesn't flash all
  // three tabs on first load before narrowing down to the correct set.
  const selectedPipeline = pipelinesList.find(
    (pipeline) => String(pipeline.id) === String(selectedPipelineId)
  );
  const showFlightsNav = selectedPipeline ? selectedPipeline.show_air !== false : false;
  const showHotelsNav = selectedPipeline ? selectedPipeline.show_hotel !== false : false;
  const showPackagesNav = selectedPipeline ? selectedPipeline.show_packages !== false : false;

  const location = useLocation();
  const [activeOption, setActiveOption] = useState(1);

  useEffect(() => {
    switch (location.pathname) {
      case "/":
        setActiveOption(1);
        break;
      case "/flights":
        setActiveOption(1);
        break;
      case "/flights/results":
        setActiveOption(1);
        break;
      case "/hotels":
        setActiveOption(2);
        break;
      case "/packages":
        setActiveOption(3);
        break;
      default:
        setActiveOption(0);
    }
  }, [location.pathname]);

  // Region/Currency selectors show on the homepage and the flights results page — everywhere
  // else (review, payment…) they're hidden entirely, so mid-flow switching there can't desync the
  // currency the results/prices on screen are already in. "Homepage" here means any of the
  // search-form landing routes (Route.js: "/", "/flights", "/hotels", "/visa", "/packages" all
  // render <HomePage>), not just the bare "/".
  const isHomepage = ["/", "/flights", "/hotels", "/visa", "/packages"].includes(
    location.pathname
  );
  const isFlightsResultsPage = location.pathname === "/flights/results";
  const showRegionCurrencySelectors = isHomepage || isFlightsResultsPage;

  // "Global" is just another real row from pipelines-public-list (PipelineController::publicList())
  // tagged with code: null — same identifying check ResultPage.jsx uses for its own Global
  // handling. A user account is scoped to a real region's pipeline, so there's nothing to log
  // into/register for while Global is selected — hide Login/Signup entirely rather than let
  // someone register under the Global pseudo-pipeline.
  const matchedSelectedPipelineForLogin = pipelinesList?.find(
    (pipeline) => String(pipeline.id) === String(selectedPipelineId)
  );
  const isGlobalPipelineSelected = matchedSelectedPipelineForLogin?.code === null;

  let navigate = useNavigate();

  // A user account is scoped to the pipeline it registered/logged in under (see
  // UserController — every lookup filters by pipeline_id), so a session from one region is
  // meaningless (and would silently 404/mismatch) once the visitor switches to another. Force a
  // logout on region switch instead of leaving a stale, wrong-region session sitting active.
  // Admins are NOT pipeline-scoped this way — they stay logged in across a region switch.
  const logoutOnPipelineSwitch = async () => {
    let token = getLocalStorageJSON("UL");
    await LogoutUser(`users/logout`, token);

    dispatch(setUserLoggedInData(null));
    removeLocalStorageJSON("UL");
    dispatch(setisUserLogin(false));
  };

  // The actual "commit the region change" logic — pulled out of the selector's onChange so it
  // can be deferred until AFTER a logged-in user confirms the logout-to-switch prompt (or run
  // immediately for admins/logged-out visitors, who don't need that confirmation at all).
  const applyPipelineSwitch = (newPipelineId) => {
    dispatch(setSelectedPipelineId(newPipelineId));
    setLocalStorageJSON("selectedPipelineId", newPipelineId);

    // Manually switching region should switch currency to match
    // it too, same as the first-visit auto-select does — straight
    // from the pipeline's own `currency` column.
    const chosenPipeline = pipelinesList.find(
      (pipeline) => String(pipeline.id) === String(newPipelineId)
    );
    // Cached as the region's own CODE (e.g. "IN", "AU"), not the raw numeric
    // pipeline id — the results URL's &pid= (HomePage-Flights-SLICE.js) uses
    // this directly, so a shareable/bookmarkable link never exposes an internal
    // database id (or lets it be guessed/enumerated by editing the URL). Global
    // (code: null — see PipelineController::publicList()) is stored as "x", the
    // same sentinel the backend's own $isGlobalPipeline check expects.
    setLocalStorageJSON(
      "selectedPipelineCode",
      chosenPipeline?.code === null ? "x" : chosenPipeline?.code ?? "x"
    );
    const matchedCurrency =
      chosenPipeline?.currency &&
      currencies.find((currency) => currency.code === chosenPipeline.currency);
    if (matchedCurrency) {
      setSelectedCurrency(matchedCurrency.code);
      setLocalStorageJSON("selectedCurrency", matchedCurrency.code);
    }

    // On the results page this selector sits outside the search bar's own
    // fields (airports/dates/travellers/fare type), so none of ITS reducers
    // fire on a region change — disableSearch was staying whatever it already
    // was (often true right after the last search finished) and the SEARCH
    // button never re-enabled. Re-using this component on the homepage too, so
    // guard: that slice's disableSearch flag only exists on the results page.
    if (isFlightsResultsPage) {
      dispatch(enableResultPageSearchButton());
    }
  };

  // Users (never admins — they stay logged in across a region switch, see
  // logoutOnPipelineSwitch above) must confirm before switching region, since it forces their
  // session out. Cancelling leaves selectedPipelineId untouched, so the controlled <select>
  // snaps back to the still-current region on its own — no extra revert logic needed.
  //
  // Switching TO Global is the one exception: Global isn't "some other region" to leave the
  // account behind for — it's just a wider search scope layered on top of whichever account the
  // visitor is already logged into. Whatever happens next (search, booking, …) still happens as
  // that same user, now just browsing under Global instead of their own region's pipeline. So a
  // logged-in user switching to Global skips the confirm/logout entirely and stays logged in.
  //
  // Same for switching back to the account's OWN region (e.g. was browsing Global, picks India
  // again and India is literally the pipeline this account is registered under) — that's not
  // actually leaving the account behind either, just returning to its native scope.
  const onPipelineSelectChange = (newPipelineId) => {
    const targetPipeline = pipelinesList?.find(
      (pipeline) => String(pipeline.id) === String(newPipelineId)
    );
    const isTargetGlobal = targetPipeline?.code === null;
    const isTargetOwnAccountPipeline =
      String(newPipelineId) === String(userLoggedInData?.pipeline_id);

    if (
      isUserLogin &&
      !isTargetGlobal &&
      !isTargetOwnAccountPipeline &&
      String(newPipelineId) !== String(selectedPipelineId)
    ) {
      Swal.fire({
        title: "You need to logout to switch to another region",
        showCancelButton: true,
        confirmButtonText: "Logout & Switch",
      }).then((result) => {
        if (result.isConfirmed) {
          logoutOnPipelineSwitch();
          applyPipelineSwitch(newPipelineId);
        }
      });
      return;
    }

    applyPipelineSwitch(newPipelineId);
  };

  return (
    <>
      <div className="topbar-navbar-navigation">
        <div className="frame-98">
          <div className="frame-99">
            <div className="frame-99-1">
              <Link to="/">
                <div className="frame-100">
                  <div className="group-168">
                    <div className="overlap-group">
                      {/* Per explicit instruction ("admin panel mein jo logo hai, isko frontend
                          mein laga do Home ki jagah") — "Home" text replaced with the actual
                          tripprizer.com logo image, matching the admin panel's own header. The
                          asset was already sitting in Assets/Images (Tripprizer-logo.svg) and
                          even already referenced here, just commented out. */}
                      <img
                        className="tripprizer-logo"
                        src={images["Tripprizer-logo.svg"]}
                        alt="TripPrizer"
                      />
                    </div>
                  </div>
                  <div className="TripPrizer"></div>
                </div>
              </Link>
              <div className="frame-9">
                {showFlightsNav && (
                <div className="frame-19">
                  <Link to="/flights">
                    <div className="frame-99-4">
                      <div className="group-108">
                        <div className="overlap-group4">
                          <div className="group-107">
                            <div className="overlap-group3">
                              <img
                                className="vector-2"
                                src={images["vector-2-6.svg"]}
                                alt="Vector 2"
                              />
                              <img
                                className="vector-3"
                                src={images["vector-3-6.svg"]}
                                alt="Vector 3"
                              />
                              <div className="group-105">
                                <div className="overlap-group2">
                                  <img
                                    className="line-6"
                                    src={images["line-6-13.svg"]}
                                    alt="Line 6"
                                  />
                                  <div className="line-container">
                                    <img
                                      className="line-7"
                                      src={images["line-7-13.svg"]}
                                      alt="Line 7"
                                    />
                                    <img
                                      className="line-8"
                                      src={images["line-8-13.svg"]}
                                      alt="Line 8"
                                    />
                                  </div>
                                </div>
                              </div>
                              <img
                                className="vector-4"
                                src={images["vector-4-6.svg"]}
                                alt="Vector 4"
                              />
                            </div>
                            <div className="group-104">
                              <img
                                className="line-6-1"
                                src={images["line-6-12.svg"]}
                                alt="Line 6"
                              />
                              <div className="line-container-1">
                                <img
                                  className="line-7-1"
                                  src={images["line-7-12.svg"]}
                                  alt="Line 7"
                                />
                                <img
                                  className="line-8-1"
                                  src={images["line-8-12.svg"]}
                                  alt="Line 8"
                                />
                              </div>
                            </div>
                          </div>
                          <img
                            className="vector-8"
                            src={images["vector-8-6.svg"]}
                            alt="Vector 8"
                          />
                        </div>
                      </div>
                      <div
                        className={`flights valign-text-middle ${
                          activeOption === 1
                            ? "proxima_semibold color_magic-potion font16"
                            : "proxima_regular color_eerie-black font16"
                        }`}
                      >
                        FLIGHTS
                      </div>
                    </div>
                  </Link>
                </div>
                )}
                {showHotelsNav && (
                <div className="frame-27">
                  <Link to="/hotels">
                    <div className="frame-99-4">
                      <img
                        className="frame-128"
                        src={images["frame-128-6.svg"]}
                        alt="Frame 128"
                      />
                      <div
                        className={`hotels valign-text-middle ${
                          activeOption === 2
                            ? "proxima_semibold color_magic-potion font16"
                            : "proxima_regular color_eerie-black font16"
                        }`}
                      >
                        HOTELS
                      </div>
                    </div>
                  </Link>
                </div>
                )}
                {showPackagesNav && (
                <div className="frame-23">
                  <Link to="/packages">
                    <div className="frame-99-4">
                      <img
                        className="hotel_building_stars"
                        src={
                          images[
                            "hotel-building-stars-holiday-vacation-icon-196736-1-3.svg"
                          ]
                        }
                        alt="hotel_building_stars_holiday_vacation_icon_196736 1"
                      />
                      <div
                        className={`packages valign-text-middle ${
                          activeOption === 3
                            ? "proxima_semibold color_magic-potion font16"
                            : "proxima_regular color_eerie-black font16"
                        }`}
                      >
                        PACKAGES
                      </div>
                    </div>
                  </Link>
                </div>
                )}
              </div>
            </div>
            <div className="frame-100-1 frame-100-4">
              {/* <div className="frame-8">
              <div className="business-travel proxima_regular color_black font16">
                BUSINESS TRAVEL
              </div>
            </div> */}
              {showRegionCurrencySelectors && (
                <>
                {
                  isAdminLogin &&
                  <select
                    className="pipeline-selector proxima_regular color_black font16"
                    value={selectedPipelineId}
                    onChange={(e) => onPipelineSelectChange(e.target.value)}
                  >
                    {pipelinesList.map((pipeline) => (
                      <option key={pipeline.id} value={pipeline.id}>
                        {pipeline.name}
                      </option>
                    ))}
                  </select>
                }
                  <div className="currency-selector-wrapper">
                    <select
                      className="pipeline-selector proxima_regular color_black font16 currency-selector-native"
                      value={selectedCurrency}
                      onChange={(e) => {
                        setSelectedCurrency(e.target.value);
                        setLocalStorageJSON("selectedCurrency", e.target.value);
                        if (isFlightsResultsPage) {
                          dispatch(enableResultPageSearchButton());
                        }
                      }}
                    >
                      {currencies.map((currency) => (
                        <option key={currency.code} value={currency.code}>
                          {currency.code} - {currency.name}
                        </option>
                      ))}
                    </select>
                    {/* Native <select> always renders the selected <option>'s full text
                        in the closed box — this label overlays just the code on top of
                        it (select's own text made transparent via CSS) so the dropdown
                        list still shows "CODE - Name" but the collapsed box shows only
                        the code. */}
                    <span className="currency-selector-label">{selectedCurrency}</span>
                  </div>
                </>
              )}
              {/* A logged-out visitor has no account to log into under the Global pseudo-pipeline
                  (accounts are scoped to a real region's pipeline), so hide the Login/Signup
                  prompt entirely while Global is selected. An already-authenticated admin (who
                  stays logged in across a region switch — see logoutOnPipelineSwitch above)
                  still gets their "Hi , Admin" shown as normal. */}
              {!(isGlobalPipelineSelected && !userLoading && isUserLogin != true && isAdminLogin != true) && (
                <div
                  className="frame-9-2"
                  onClick={() => {
                    // While AuthenticateUser() is still resolving (e.g. exchanging the
                    // admin panel's one-time "Visit Portal" SSO ticket), isUserLogin/isAdminLogin
                    // are both still their default `false` — clicking here would wrongly pop the
                    // sign-up popup for someone who's actually about to be logged in. Ignore
                    // clicks until userLoading settles either way.
                    if (userLoading) {
                      return;
                    }
                    if (isUserLogin == true || isAdminLogin == true) {
                      navigate("/user")
                    } else {
                      dispatch(setShowSignUpPopup(true));
                    }
                  }}
                >
                  <div className="login-signup">
                    {userLoading
                      ? "Logging in…"
                      : isUserLogin == true || isAdminLogin == true
                      ? `Hi , ${isAdminLogin == true ? "Admin" : "Traveller"}`
                      : "Login / Signup"}
                  </div>
                </div>
              )}
              {/* <div className="frame-8-1">
              <div className="frame-266">
                <div className="en-inr proxima_regular color_black font16">
                  EN / INR
                </div>
                <img className="vector" src={images['vector-14.svg']} alt="Vector" />
              </div>
            </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
